import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { mapEmspBoTransactionStatusToStyle } from '../emsp-bo-charging-session-status.helper';

interface EmspBoChargingSessionListStatusCellProps
  extends CellContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['status']
  > {}

export const EmspBoChargingSessionListStatusCell = ({
  getValue,
}: EmspBoChargingSessionListStatusCellProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  const value = getValue();
  const latest = value.at(-1);

  if (!latest) {
    return <span>—</span>;
  }

  const { color } = mapEmspBoTransactionStatusToStyle(latest.type);

  return (
    <Tag className={classNames(color)}>
      <Text italic fontSize={TextFontSize.Small}>
        {t(`delmonicos-shared-sdk.enums-transaction-status.${latest.type}`)}
      </Text>
    </Tag>
  );
};
